import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "51.589",
  height: "57.537",
  viewBox: "0 0 51.589 57.537"
}
const _hoisted_2 = { transform: "translate(1.077 1)" }
const _hoisted_3 = { transform: "translate(26.51 0)" }
const _hoisted_4 = ["stroke"]
const _hoisted_5 = ["stroke"]
const _hoisted_6 = ["stroke"]
const _hoisted_7 = { transform: "translate(4.613 40.157)" }
const _hoisted_8 = ["stroke"]
const _hoisted_9 = ["stroke"]
const _hoisted_10 = { transform: "translate(10.599 10.797)" }
const _hoisted_11 = ["stroke"]
const _hoisted_12 = ["stroke"]
const _hoisted_13 = ["stroke"]
const _hoisted_14 = ["stroke"]
const _hoisted_15 = { transform: "translate(0 0)" }
const _hoisted_16 = ["stroke"]
const _hoisted_17 = ["stroke"]
const _hoisted_18 = { transform: "translate(7.712)" }
const _hoisted_19 = ["stroke"]
const _hoisted_20 = ["stroke"]
const _hoisted_21 = ["stroke"]
const _hoisted_22 = ["stroke"]
const _hoisted_23 = ["stroke"]


export default /*#__PURE__*/_defineComponent({
  __name: 'IconPower3',
  props: {
  color: {
    type: String,
    default: '#D4D4D4',
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("g", _hoisted_2, [
      _createElementVNode("g", _hoisted_3, [
        _createElementVNode("g", null, [
          _createElementVNode("path", {
            d: "M364.157,190.169c0,3.122-2.2,6.013-4.92,6.013s-4.92-2.891-4.92-6.013a4.933,4.933,0,1,1,9.84,0Z",
            transform: "translate(-350.246 -184.878)",
            fill: "none",
            stroke: __props.color,
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
          }, null, 8, _hoisted_4),
          _createElementVNode("path", {
            d: "M358.606,215.177h-9.447a3.206,3.206,0,0,0-2.829,2.02l-1.177,3.431",
            transform: "translate(-345.153 -201.715)",
            fill: "none",
            stroke: __props.color,
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
          }, null, 8, _hoisted_5),
          _createElementVNode("path", {
            d: "M361.834,236.616l1.583,12.7a1.111,1.111,0,0,1-1.128,1.272H348.9a1.111,1.111,0,0,1-1.128-1.272L350,230.861",
            transform: "translate(-346.604 -210.431)",
            fill: "none",
            stroke: __props.color,
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
          }, null, 8, _hoisted_6),
          _createElementVNode("g", _hoisted_7, [
            _createElementVNode("path", {
              d: "M359.914,275.263v13.243a2.142,2.142,0,0,1-2.136,2.136h-.107a2.142,2.142,0,0,1-2.136-2.136V275.263",
              transform: "translate(-355.535 -275.263)",
              fill: "none",
              stroke: __props.color,
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2"
            }, null, 8, _hoisted_8),
            _createElementVNode("path", {
              d: "M369.77,275.263v13.243a2.142,2.142,0,0,1-2.136,2.136h-.107a2.142,2.142,0,0,1-2.136-2.136V275.263",
              transform: "translate(-361.012 -275.263)",
              fill: "none",
              stroke: __props.color,
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2"
            }, null, 8, _hoisted_9)
          ])
        ]),
        _createElementVNode("g", _hoisted_10, [
          _createElementVNode("path", {
            d: "M370.722,224.517c-2.953-1.6-1.812-7.008,1.3-12.754a4.932,4.932,0,1,1,8.672,4.7",
            transform: "translate(-369.008 -209.18)",
            fill: "none",
            stroke: __props.color,
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
          }, null, 8, _hoisted_11),
          _createElementVNode("path", {
            d: "M375.408,223.447c-1.653,1.344-3.278,1.834-4.686,1.071-2.953-1.6-1.812-7.008,1.3-12.754a4.932,4.932,0,1,1,8.672,4.7,33.4,33.4,0,0,1-2.416,3.852",
            transform: "translate(-369.008 -209.18)",
            fill: "none",
            stroke: __props.color,
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
          }, null, 8, _hoisted_12),
          _createElementVNode("path", {
            d: "M383.515,214.667a2.636,2.636,0,1,1-3.574,1.062A2.635,2.635,0,0,1,383.515,214.667Z",
            transform: "translate(-374.906 -212.052)",
            fill: "none",
            stroke: __props.color,
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
          }, null, 8, _hoisted_13)
        ]),
        _createElementVNode("path", {
          d: "M1.832,0h0A1.833,1.833,0,0,1,3.665,1.833V6.767A1.833,1.833,0,0,1,1.833,8.6h0A1.833,1.833,0,0,1,0,6.767V1.832A1.832,1.832,0,0,1,1.832,0Z",
          transform: "translate(13.455 23.88) rotate(-72.89)",
          fill: "none",
          stroke: __props.color,
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2"
        }, null, 8, _hoisted_14)
      ]),
      _createElementVNode("g", _hoisted_15, [
        _createElementVNode("line", {
          y2: "20.933",
          transform: "translate(18.888 21.164)",
          fill: "none",
          stroke: __props.color,
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2"
        }, null, 8, _hoisted_16),
        _createElementVNode("line", {
          y1: "20.933",
          transform: "translate(6.765 21.164)",
          fill: "none",
          stroke: __props.color,
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2"
        }, null, 8, _hoisted_17),
        _createElementVNode("g", null, [
          _createElementVNode("g", _hoisted_18, [
            _createElementVNode("path", {
              d: "M313.073,190.378c0,3.245-2.29,6.25-5.115,6.25s-5.114-3.006-5.114-6.25a5.128,5.128,0,1,1,10.229,0Z",
              transform: "translate(-302.844 -184.878)",
              fill: "none",
              stroke: __props.color,
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2"
            }, null, 8, _hoisted_19)
          ]),
          _createElementVNode("path", {
            d: "M306.783,258.852v18.883a2.779,2.779,0,0,1-2.771,2.771h-.529a2.779,2.779,0,0,1-2.771-2.771V257.022",
            transform: "translate(-293.947 -224.969)",
            fill: "none",
            stroke: __props.color,
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
          }, null, 8, _hoisted_20),
          _createElementVNode("path", {
            d: "M320.405,257.022v20.712a2.779,2.779,0,0,1-2.771,2.771h-.529a2.779,2.779,0,0,1-2.771-2.771V258.852",
            transform: "translate(-301.517 -224.969)",
            fill: "none",
            stroke: __props.color,
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
          }, null, 8, _hoisted_21),
          _createElementVNode("path", {
            d: "M328,231.391l3.366,10.642a1.75,1.75,0,0,0,2.194,1.061l.042-.014a1.96,1.96,0,0,0,.837-.454,2.4,2.4,0,0,0,.744-1.1L339,230.882",
            transform: "translate(-309.113 -210.443)",
            fill: "none",
            stroke: __props.color,
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
          }, null, 8, _hoisted_22),
          _createElementVNode("path", {
            d: "M313,218.3l-3.09,9.125-1.824-8.616-.181-.468a3.206,3.206,0,0,0-2.829-2.02H291.548a3.207,3.207,0,0,0-2.829,2.02l-.176.468-2.967,14.012a1.714,1.714,0,0,0,1.071,2.167l.041.014a1.751,1.751,0,0,0,2.195-1.061l3.366-10.642",
            transform: "translate(-285.486 -202.352)",
            fill: "none",
            stroke: __props.color,
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
          }, null, 8, _hoisted_23)
        ])
      ])
    ])
  ]))
}
}

})